import { render, staticRenderFns } from "./ModalEditAddress.vue?vue&type=template&id=35cd9ece&"
import script from "./ModalEditAddress.vue?vue&type=script&lang=js&"
export * from "./ModalEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports